module.exports = __webpack_public_path__ + "static/img/dataBottom.0df4d8b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/dataBottom.jpg
// module id = u5Dd
// module chunks = 0